/**
 * §7.3: scheduled times show in the bot's timezone with the viewer's local time
 * alongside. An owner in one zone scheduling for an audience in another gets
 * both readings without doing arithmetic.
 */

import { localDateTime, localZoneName, zonedDateTime } from '../lib/format';

export function BotTime({ iso, timeZone }: { iso: string | null; timeZone: string }) {
  if (!iso) return <span className="muted">—</span>;
  const local = localZoneName();
  const sameZone = local === timeZone;
  return (
    <span className="time">
      <time dateTime={iso}>{zonedDateTime(iso, timeZone)}</time>
      <span className="time-zone"> {timeZone}</span>
      {sameZone ? null : (
        <span className="time-local"> · {localDateTime(iso)} your time</span>
      )}
    </span>
  );
}

export function LocalTime({ iso }: { iso: string | null }) {
  if (!iso) return <span className="muted">—</span>;
  return <time dateTime={iso}>{localDateTime(iso)}</time>;
}
